import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleViewer from '../../components/ArticleViewer';
import { PUBLIC_ROUTES } from '../../../../constants/routes';
import '../getting-started/HelpCategoryPage.css';

/**
 * Privacy Settings Article Page
 */
const Privacy = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer 
              title="Privacy Settings"
              showQA={true}
              articleId="privacy"
            >
              <div className="article-content">
                <p>
                  Control your privacy and data sharing preferences to keep your information
                  secure and visible only to those you choose.
                </p>
                
                <h2>Profile Visibility</h2>
                <p>Control who can see your profile:</p>
                <ul>
                  <li><strong>Public:</strong> Anyone can find and view your profile</li>
                  <li><strong>Contacts Only:</strong> Only people in your contacts can see you</li>
                  <li><strong>Private:</strong> Only people you approve can see your profile</li>
                </ul>

                <h2>Friend Requests</h2>
                <p>
                  Choose who can send you friend requests. You can require approval for all
                  requests or only allow requests from contacts.
                </p>

                <h2>Activity Visibility</h2>
                <p>
                  Control what information is visible to others:
                </p>
                <ul>
                  <li>Hide your split activity from others</li>
                  <li>Control who can see your transaction history</li>
                  <li>Manage wallet visibility settings</li>
                </ul>

                <h2>Data Sharing</h2>
                <p>
                  Manage how WeSplit uses your data:
                </p>
                <ul>
                  <li>Opt out of analytics and usage tracking</li>
                  <li>Control marketing communications</li>
                  <li>Manage third-party data sharing</li>
                </ul>

                <h2>Account Deletion</h2>
                <p>
                  You can request account deletion at any time. This will permanently remove
                  your account and all associated data.
                </p>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Privacy;
